import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';

interface ImagePreviewProps {
  image: string | null;
  onClose: () => void;
}

export function ImagePreview({ image, onClose }: ImagePreviewProps) {
  return (
    <Dialog open={!!image} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl">
        <DialogTitle className="sr-only">Screenshot Preview</DialogTitle>
        {image && (
          <div className="relative">
            <img 
              src={image} 
              alt="Screenshot preview" 
              className="w-full rounded-lg"
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}